module.exports = __webpack_public_path__ + "img/rest-def.b7d08c11.png";